import React from 'react';
import { ArrowLeft, Search, X, Loader2 } from 'lucide-react';
import { SEARCH_TYPES } from './searchConfig';

function SearchHeader({
  query,
  onQueryChange,
  activeType,
  onTypeChange,
  onSubmit,
  onClear,
  onBackClick,
  loading,
  counts,
}) {
  return (
    <div className="bg-white border-b border-slate-200 sticky top-0 z-20 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-3 mb-4">
          <button
            type="button"
            onClick={onBackClick}
            className="inline-flex items-center gap-2 text-slate-700 hover:text-brand-primary transition-colors font-montserrat font-semibold"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Volver</span>
          </button>

          <div className="text-right">
            <h1 className="text-xl sm:text-2xl font-extrabold text-slate-900 font-montserrat">
              Busqueda Global
            </h1>
            <p className="text-xs text-slate-500 font-montserrat">
              Entregas, recojos, provincia, express, usuarios y paquetes
            </p>
          </div>
        </div>

        <form onSubmit={onSubmit} className="relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
          <input
            autoFocus
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="ID, telefono, DNI, tracking, nombre, direccion, estado..."
            className="w-full rounded-xl border-2 border-slate-200 bg-slate-50 pl-12 pr-28 py-3 text-sm sm:text-base font-montserrat focus:outline-none focus:ring-2 focus:ring-brand-primary/20 focus:border-brand-primary"
          />
          <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
            {query && (
              <button
                type="button"
                onClick={onClear}
                className="p-2 rounded-lg text-slate-400 hover:bg-white hover:text-slate-700"
                title="Limpiar"
              >
                <X className="w-4 h-4" />
              </button>
            )}
            <button
              type="submit"
              disabled={loading || !query.trim()}
              className="inline-flex items-center gap-2 rounded-lg bg-brand-primary px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 disabled:cursor-not-allowed hover:bg-brand-primary/90 transition-colors"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
              Buscar
            </button>
          </div>
        </form>

        <div className="mt-3 flex gap-2 overflow-x-auto pb-1">
          {SEARCH_TYPES.map((type) => {
            const Icon = type.icon;
            const active = activeType === type.id;
            const count = counts?.[type.id];
            return (
              <button
                key={type.id}
                type="button"
                onClick={() => onTypeChange(type.id)}
                className={`inline-flex shrink-0 items-center gap-2 rounded-lg border px-3 py-2 text-sm font-semibold transition-colors ${
                  active
                    ? 'border-brand-primary bg-brand-primary text-white'
                    : 'border-slate-200 bg-white text-slate-600 hover:border-brand-primary/40 hover:text-brand-primary'
                }`}
              >
                <Icon className="w-4 h-4" />
                {type.label}
                {Number.isFinite(count) && type.id !== 'all' && (
                  <span className={`rounded-full px-1.5 py-0.5 text-[11px] ${active ? 'bg-white/20' : 'bg-slate-100'}`}>
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default SearchHeader;
